'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (theme) {
  return {
    txt: {
      position: 'relative',
      paddingTop: 4,
      paddingBottom: 16,
      color: theme.textColor,
      '& input': {
        color: theme.textColor,
        backgroundColor: 'transparent',
        padding: '8px 0',
        border: 'none',
        outline: 'none',
        height: '100%',
        boxSizing: 'content-box',
        display: 'block',
        fontSize: theme.autocomplete.fontSizeMedium,
        minWidth: 0,
        flexGrow: 1
      },
      '& input::placeholder': {
        color: theme.autocomplete.placeholder
      },
      '&.leftIcon $label': {
        transform: 'scale(1) translate(24px, 0px)'
      },
      '&.selected $label': {
        transform: 'scale(0.71) translate(0px, -24px)'
      },
      '&.selected $field': {
        borderBottomColor: theme.textColor
      },
      '&.focus $field': {
        borderBottomColor: theme.primaryColor
      },
      '&.focus $label': {
        color: theme.primaryColor
      },
      '&.error $field': {
        borderBottomColor: theme.errorColor,
        color: theme.errorColor
      },
      '&.error $label': {
        color: theme.errorColor
      },
      '&.hidden': {
        display: 'none'
      },
      '&.disabled': {
        opacity: theme.disabledOpacity,
        cursor: 'default'
      }
    },
    field: {
      display: 'flex',
      borderBottomColor: theme.autocomplete.borderColor,
      borderBottomStyle: 'solid',
      position: 'relative',
      padding: '8px 0 0 0',
      transition: theme.transition(['all']),
      borderBottomWidth: theme.autocomplete.borderWidthMedium,
      alignItems: 'center'
    },
    rightText: {
      cursor: 'pointer',
      flex: '0 0 auto',
      color: theme.autocomplete.rightTextColor
    },
    fieldInput: {
      display: 'inline-flex',
      flexWrap: 'wrap',
      width: '100%',
      alignItems: 'center'
    },
    label: {
      position: 'absolute',
      top: 16,
      transition: theme.transition(['all']),
      transform: 'scale(1) translate(0px, 0px)',
      transformOrigin: 'left top 0px'
    },
    helperText: {
      position: 'absolute',
      fontSize: 10,
      marginTop: 4,
      '&.error': {
        color: theme.errorColor
      }
    },
    passIcon: {
      position: 'absolute',
      right: 0,
      cursor: 'pointer'
    },
    searchList: {
      position: 'absolute',
      left: 0,
      width: '100%',
      boxSizing: 'border-box',
      padding: '8px 0',
      maxHeight: '288px',
      overflow: 'auto',
      backgroundColor: theme.autocomplete.searchBackgroundColor,
      boxShadow: theme.autocomplete.boxShadow,
      transition: theme.transition(['height']),
      zIndex: 10
    },
    searchResult: {
      maxHeight: 280,
      overflow: 'scroll',
      zIndex: 10
    }
  };
};